<div class="create-simulation-page">
  <!-- <qai-inner-wrap> -->
  <!-- HEADER -->
  <header *ngIf="!loading" class="page-header">
    <!-- Row 1: Breadcrumbs & Actions -->
    <div class="header-row-one">
      <div class="breadcrumb-container">
        <qai-breadcrumb-list
          [items]="[
            {
              text: ('simulationBuilder.SIMULATIONS_TAB_LABEL' | transloco),
              href: '/self-serve?fromSimulationDetails=true'
            },
            {
              text: simulationName,
              active: true
            }
          ]"
        ></qai-breadcrumb-list>
      </div>

      <div class="header-actions">
        <span class="header-label">
          {{ 'simulationBuilder.LAST_SAVED_LABEL' | transloco | localeLabel : ((showLegacyKnowledgeCheckView ? simulationDetails?.updatedAt : lastSaved) | localeDate : 'datetime') }}
        </span>

        <ng-container *ngIf="!showLegacyKnowledgeCheckView && !isLegacyCall">
          <ng-container *ngIf="isSelfAuthoring || showKnowledgeCheckTabs">
          <button
            qai-button
            size="medium"
            kind="tertiary"
            [disabled]="!canTestSimulation"
            (click)="handleTestSimulationClick()"
          >
            {{ 'simulationBuilder.TEST_SIMULATION_BUTTON' | transloco }}
          </button>
        </ng-container>
        @if (isSelfAuthoring || showKnowledgeCheckTabs) {
          <button
            qai-button
            size="medium"
            kind="primary"
            [disabled]="!canExportCallDetails"
            (click)="handleExportCallDetailsClick()"
          >
            {{ 'simulationBuilder.EXPORT_SIMULATION_SUMMARY_BUTTON' | transloco }}
          </button>
        }
        <ng-container *ngIf="readOnly === false">
          <span #publishBtnWrapper>
            <button
              qai-button
              size="medium"
              kind="primary"
              [disabled]="!isReadyForPublish || readOnly || isRefinementInProgress"
              (click)="publishSimulation()"
            >
              Publish simulation
            </button>
          </span>
          <qai-tooltip
            *ngIf="isRefinementInProgress"
            [qaiFloating]="publishBtnWrapper"
            [placement]="'below-center'"
            [events]="['hover']"
          >
            {{ 'simulationBuilder.REFINEMENT_IN_PROGRESS_TOOLTIP' | transloco }}
          </qai-tooltip>
          <qai-tooltip
            *ngIf="!isRefinementInProgress && !showKnowledgeCheckTabs && (isV2WithNoFacts || isMissingMessagingThemes)"
            [qaiFloating]="publishBtnWrapper"
            [placement]="'below-center'"
            [events]="['hover']"
          >
            Add at least one fact to Message Adherence before testing or publishing.
          </qai-tooltip>
          <qai-tooltip
            *ngIf="!isRefinementInProgress && !showKnowledgeCheckTabs && !isV2WithNoFacts && !isMissingMessagingThemes && hasEmptyFacts"
            [qaiFloating]="publishBtnWrapper"
            [placement]="'below-center'"
            [events]="['hover']"
          >
            {{ 'simulationBuilder.FACTS_CANNOT_BE_EMPTY' | transloco }}
          </qai-tooltip>
          <qai-tooltip
            *ngIf="!isRefinementInProgress && !showKnowledgeCheckTabs && !isV2WithNoFacts && !isMissingMessagingThemes && !hasEmptyFacts && isMissingSkillsRubric"
            [qaiFloating]="publishBtnWrapper"
            [placement]="'below-center'"
            [events]="['hover']"
          >
            {{ 'simulationBuilder.SKILLS_RUBRIC_REQUIRED_TOOLTIP' | transloco }}
          </qai-tooltip>
          <qai-tooltip
            *ngIf="showKnowledgeCheckTabs && (hasIncompleteKnowledgeCheckQuestions || hasKnowledgeCheckQuestionWithoutAnswerPoints || hasIncompleteKnowledgeCheckAnswerPoints)"
            [qaiFloating]="publishBtnWrapper"
            [placement]="'below-center'"
            [events]="['hover']"
          >
            {{ 'simulationBuilder.KNOWLEDGE_CHECK_INCOMPLETE_CONTENT_TOOLTIP' | transloco }}
          </qai-tooltip>
        </ng-container>
        <qai-kebab-menu
          *ngIf="!showKnowledgeCheckTabs"
          [items]="options"
          (itemClicked)="onKebabMenuAction($event)"
          [placement]="'below-start'"
          [size]="'24px'"
        ></qai-kebab-menu>
        </ng-container>
      </div>
    </div>

    <div *ngIf="!showLegacyKnowledgeCheckView && !isLegacyCall">
      <!-- Row 2: Tabs -->
      <div class="header-row-two">
        <qai-tabs (tabSelected)="onTabSelected($event)">
          @for (tab of visibleTabs; track tab.id) {
            <ng-template [qaiTab]="tab.id" [label]="tab.label | transloco">
              @switch (tab.id) {
                @case (SimBuilderTabValues.GeneralId)  { @if (showKnowledgeCheckTabs) { <tabs-inner-wrap><knowledge-check-simulation-information /><knowledge-check-scoring-section /></tabs-inner-wrap> } @else { <tab-general-content [isSelfAuthoring]="isSelfAuthoring" [conversePromptManualOverride]="simulationDetails?.conversePromptManualOverride ?? false" /> } }
                @case (SimBuilderTabValues.ContentsId) { <tab-content-details [isQcAdmin]="isQcAdmin" [isRefinementInProgress]="isRefinementInProgress" (conversePromptOverridden)="handleConversePromptOverridden()" /> }
                @case (SimBuilderTabValues.KeyWordsId) { <tab-key-words-details [isSelfAuthoring]="isSelfAuthoring" /> }
                @case (SimBuilderTabValues.ScoringId)  { <tab-scoring-details [isSelfAuthoring]="isSelfAuthoring" /> }
                @case (SimBuilderTabValues.TestingId)  { @if (!showKnowledgeCheckTabs) { <tab-testing-details [isSelfAuthoring]="isSelfAuthoring" /> } }
                @case (SimBuilderTabValues.WhatUsersSeeId) { <tab-what-users-see [isKnowledgeCheck]="showKnowledgeCheckTabs" /> }
                @case (SimBuilderTabValues.QuestionsId) { <knowledge-check-questions-tab /> }
              }
            </ng-template>
          }
        </qai-tabs>
      </div>
    </div>
  </header>

  <div *ngIf="showLegacyKnowledgeCheckView && simulationDetails">
    <guided-simulation-details [simulationDetails]="simulationDetails"></guided-simulation-details>
  </div>

  <tabs-inner-wrap *ngIf="isLegacyCall && simulationDetails">
    <div class="legacy-call-card">
      <qai-simulation-card
        [title]="simulationDetails!.name"
        [callType]="simulationDetails!.callType ? (simulationDetails!.callType | capitalize) + ' ' + ('simulationBuilder.CALL' | transloco) : ''"
        [description]="simulationDetails!.description"
        [showCallDetailsButton]="true"
        [showCallDetailsButtonDisabled]="previewModalButtonState"
        (callDetailsClick)="callDetailsClick($event)"
        [avatarImageSrc]="simulationDetails!.avatarUrl"
      ></qai-simulation-card>
    </div>
  </tabs-inner-wrap>

  <preview-simulations-details-modal
    *ngIf="isLegacyCall"
    [open]="openPreviewModal"
    [tabs]="previewTabs"
    (closeModal)="handlePreviewModalClose()"
  ></preview-simulations-details-modal>
</div>

<delete-modal
  [open]="isDeleteModalOpen"
  (openChange)="isDeleteModalOpen = $event"
  (confirm)="confirmDelete()"
  (closeModal)="isDeleteModalOpen = false"
  [networkRequestInProgress]="networkRequestInProgress"
  [type]="EntityType.SIMULATION"
>

</delete-modal>

<action-modal
  [open]="duplicateModalVisible"
  [entityType]="EntityType.SIMULATION"
  [entityActionType]="EntityActionType.DUPLICATE"
  [originalName]="simulationToDuplicateName"
  [networkRequestInProgress]="networkRequestInProgress"
  [errorStatus]="modalErrorStatus"
  (confirmAction)="onSimulationDuplicated($event)"
  (closeModal)="closeDuplicateModal()"
></action-modal>

<publish-simulation-modal
  [open]="openPublishModal"
  [isKnowledgeCheck]="showKnowledgeCheckTabs"
  (confirm)="handlePublishModalConfirm()"
  (closeModal)="handlePublishModalClose()"
></publish-simulation-modal>

<edit-simulation-tags-modal
  [open]="isEditTagsModalOpen"
  [simulation]="simulationDetails ?? undefined"
  (saved)="refreshSimulationTags()"
  (closeModal)="isEditTagsModalOpen = false"
></edit-simulation-tags-modal>
